//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppResult',
  props: ['result', 'openInNewWindow'],
  data() {
    return {
      isAddToCartDisabled: false,
      isContactUsDisabled: false
    }
  },
  computed:  {
    targetAttribute() {
      return this.openInNewWindow ? '_blank' : '_self';
    },
    imgSrc() {
      if (!this.result || !this.result.image) return '';

      if (this.options.tempImages) {
        const width = (Math.floor(Math.random() * 31) + 20) * 5;
        const height = (Math.floor(Math.random() * 31) + 20) * 5;
        return `https://placehold.co/${width}x${height}`;
      }
      else {
        let baseUrl = this.result.image.split('?')[0];
        return `${baseUrl}?width=${250}`;
      }
    },
    hasResults() {
      return this.$store.getters.results.itemResults && this.$store.getters.results.itemResults.length;
    },
    loading() {
      return this.$store.getters.reloading || !this.$store.getters.loaded;
    },
    isAvailableForSale() {
      if (!this.result || !this.result.meta || !this.result.meta.IsAvailableForSale) {
        return false;
      }

      return this.result.meta.IsAvailableForSale.toLowerCase() === 'true';
    }
  },
  methods: {
    onAddToCart() {
      this.isAddToCartDisabled = true;
    },
    onBrandClick() {
      const brandId = this.result?.meta?.brandId;
      if (!brandId) return;

      this.$store.commit('setFilterValue', { filter: { id: brandId }, value: true });
      this.$store.commit('clearPreviousItemResults');
      this.$store.dispatch('executeSearch');
    },
    onContactUsClick() {
      this.isContactUsDisabled = true;
    }
  }
}
